import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "ChipLabel" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["ChipContainer", _ctx.currentChipState]),
    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.incentiveClicked && _ctx.incentiveClicked(...args)))
  }, [
    _createElementVNode("div", _hoisted_1, _toDisplayString(_ctx.chipLabel), 1 /* TEXT */),
    _createElementVNode("div", {
      class: _normalizeClass(["IconContainer", _ctx.currentChipState])
    }, [
      _createElementVNode("i", {
        class: _normalizeClass(["ChipIcon", _ctx.chipIcon])
      }, null, 2 /* CLASS */)
    ], 2 /* CLASS */)
  ], 2 /* CLASS */))
}